<template>
  <div class="szw-row szw-rounded-lg w-full szw-bg-color-primary">
    <div class="szw-row szw-p-2 szw-w-full szw-max-w-[768px] szw-bg-transparent szw-overflow-hidden szw-h-full szw-mx-auto">
      <!-- BACK ICON -->
      <div v-if="props.hasBack" class="szw-h-6 szw-w-6 szw-rounded szw-bg-white/10 szw-animate-pulse szw-mr-1"></div>

      <!-- TEXT -->
      <div :class="[`szw-col${props.hasBack ? '__center' : ''} szw-overflow-hidden szw-gap-1`]" :style="{ width: `calc(100% - ${props.hasBack ? '3rem' : ''})` }">
        <!-- CAPTION TITLE -->
        <span class="szw-h-5 szw-w-28 szw-rounded szw-bg-white/10 szw-animate-pulse">{{ props.title }}</span>
        <!-- CAPTION SUBTITLE -->
        <span v-if="hasSubtitle" class="szw-h-4 szw-w-40 szw-rounded szw-bg-white/10 szw-animate-pulse">{{ props.subtitle }}</span>
      </div>

      <!-- ICON | LOGO -->
      <template v-if="rightSectionType !== 'none'">
        <div v-if="rightSectionType === 'icon'" class="szw-h-6 szw-w-6 szw-rounded szw-bg-white/10 szw-animate-pulse szw-ml-auto"></div>
        <div v-else-if="rightSectionType === 'logo'" class="szw-h-8 szw-w-8 szw-rounded-full szw-bg-white/10 szw-animate-pulse szw-ml-auto"></div>
      </template>
    </div>
  </div>
</template>

<script setup>
/** @type {{ rightSectionType: '' | 'icon' | 'logo' }} */
const props = defineProps({
  hasBack: {
    type: Boolean,
    default: () => false
  },
  rightSectionType: {
    type: String,
    default: 'none'
  },
  hasSubtitle: {
    type: Boolean,
    default: false
  }
})
</script>
